var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnavailableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f04b41",
    stroke: "#efefef",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 20,
    stroke: "none",
    width: 40
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 36,
    rx: 18,
    width: 36,
    x: 2,
    y: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.141 0h-14.141",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 15.001 24.999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.142 0h-14.142",
    transform: "matrix(-.70710678 -.70710678 .70710678 -.70710678 25 25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableIcon);
export default __webpack_public_path__ + "static/media/unavailable-icon.f0bee5ec.svg";
export { ForwardRef as ReactComponent };